import { html } from '../html.js';
import { DEFAULT_PRINT_OPTIONS } from '../print-options.js';
import { t } from '../strings.js';
import { docDate, field, fields, footer, header, ltr } from './parts.js';
import { notesBlock, party, pricedLineTable, reasonLabel, statusBadge, statusLabel, totalsBlock, yesNo, } from './record-parts.js';
/**
 * SAL-05's credit note as a printed document.
 *
 * The one fact a credit note must carry that an invoice does not: WHICH
 * INVOICE it credits, by code, so the customer's bookkeeper can match the two
 * without a phone call. Alongside it the REASON (SAL-05's closed list), and
 * whether the goods were restocked — the figure is the same either way, but
 * a credit for goods that never came back is a different conversation.
 */
export function creditNoteHtml(data, locale, company, generatedAt, generatedBy, print = DEFAULT_PRINT_OPTIONS) {
    return html `
    ${header(company, t('creditNoteTitle', locale), statusBadge(data.status, locale))}
    ${fields([
        field(t('creditNoteNo', locale), ltr(data.code)),
        field(t('invoiceDate', locale), docDate(data.creditDate)),
        field(t('customerCode', locale), ltr(data.partnerCode)),
        field(t('status', locale), statusLabel(data.status, locale)),
        ...(data.invoiceCode === null ? [] : [field(t('invoiceRef', locale), ltr(data.invoiceCode))]),
        field(t('reason', locale), reasonLabel(data.reason, locale)),
        field(t('restocked', locale), yesNo(data.restock, locale)),
    ])}
    ${party(t('customer', locale), data.partnerName)}
    ${pricedLineTable(data.lines, data.currency, locale, print)}
    ${totalsBlock(data, locale, print)}
    ${notesBlock(t('reasonNote', locale), data.reasonNote)}
    ${notesBlock(t('notes', locale), data.notes)}
    ${footer(locale, generatedAt, company.name, generatedBy)}
  `;
}
//# sourceMappingURL=credit-note.js.map